import React, { Fragment } from 'react';
import { Grid, Checkbox, FormLabel, Paper } from '@material-ui/core';
import { useStyle } from './style';

export default function EirTermsAndConditions(props) {

    const { setEirTandCStatus } = props;
    const { setEirTandCError } = props;
    const eirTandCError = props.eirTandCError;
    const classes = useStyle();

    const handleChange = (event) => {
        setEirTandCStatus(event.target.checked);
        setEirTandCError(!(event.target.checked));
    };

    return (
        <Fragment>
            <Grid item sm={12} className={classes.termsAndCondition}>
                <Paper className={classes.PaymentPaper} variant='elevation' elevation={4}>
                    <Grid Container>
                        <Grid item sm={6}>
                            <h2 className={classes.TandCTitle}>eir terms & conditions</h2>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                {(JSON.parse(localStorage.getItem("eir_be_data")).mobilesOnOrder && (JSON.parse(localStorage.getItem("eir_be_data")).mobilesOnOrder.length > 0)) ?
                                    <FormLabel className={classes.paymentFormLabelColor}>
                                        By submitting this order you agree to share this information with eircom Limited (eir). This data will be used in line with eir's privacy policy. To view the eir Privacy Policy please click <a href="/privacystatement" target="_blank" className={classes.TCText}>here</a>. I also understand and agree to the eir <a href="/termsandconditions/" target="_blank" className={classes.TCText}>terms and conditions</a>. I agree that my order may not progress until all documentation is received. Please also note that mobile customers may be subject to pay a device deposit, which is refunded after 6 months, before your order is processed. If a deposit is required we will contact you and I give consent to be contacted by eir about this application.
                                    </FormLabel>
                                    :
                                    <FormLabel className={classes.paymentFormLabelColor}>
                                        By submitting this order you agree to share this information with eircom Limited (eir). This data will be used in line with eir's privacy policy. To view the eir Privacy Policy please click <a href="/privacystatement" target="_blank" className={classes.TCText}>here</a>. I also understand and agree to the eir <a href="/termsandconditions/" target="_blank" className={classes.TCText}>terms and conditions</a>.If any additional information is required we will contact you and I give consent to be contacted by eir about this application.
                                    </FormLabel>
                                }
                            </Grid>
                        </Grid>
                        <Grid item sm={12} className={classes.TandCcheckboxContainer + " TandCcheckboxContainer"}>
                            <Checkbox
                                color="primary"
                                onChange={(event) => handleChange(event)}
                                className={classes.TandCcheckbox}
                            />
                            <FormLabel className={classes.checkboxTxt} >
                                I have read and agree to eir’s <a href=" /termsandconditions/" target="_blank" className={classes.TCText}>terms and conditions </a><span style={{ color: 'red', textAlign: 'center' }} >*</span>  </FormLabel>
                        </Grid>
                        {eirTandCError &&
                            <p className={classes.errorMessageTnC}>
                                Please check the box to confirm you have read and accept eir's Terms and Conditions.</p>}
                    </Grid>
                </Paper>
            </Grid>
        </Fragment>
    );
}